import Contact from "../sections/contact/ContactBasic";

export default function ContactUs() {
  return (
    <>
      <Contact />
    </>
  );
}
